/* eslint-disable */
define((require) => {
    const _ = require('underscore')
    const d3 = require('d3')
    const VizBase = require('./VizBase')
    const metrics = require('./Metrics')
    const tutil = require('./TrackUtil')
    const trajectory = require('./Trajectory')
    const xform = require('./Transform')
    // maps EVENT_TYPES to display text
    const EVENT_TEXT = {
        SINGLE: ['SINGLE'],
        DOUBLE: ['DOUBLE'],
        TRIPLE: ['TRIPLE'],
        HOME_RUN: ['HOME RUN'],
        ITP_HOME_RUN: ['INSIDE THE PARK', 'HOME RUN'],
        POP_UP: ['POP UP'],
        FLY_BALL: ['FLY BALL'],
        SAC_FLY: ['SAC FLY'],
        LINE_DRIVE: ['LINE DRIVE'],
        OTHER: ['-----'],
    }
    const isServerSide = typeof window === 'undefined'
    let fs

    function VizHitTracking(sel) {
        _.extend(this, VizBase)
        this.sel = sel
    }

    function toRadians(deg) {
        return (Math.PI * deg) / 180
    }

    function toDegrees(rad) {
        return (180 * rad) / Math.PI
    }

    function dist(p1, p2) {
        const dx = p2.x - p1.x
        const dy = p2.y - p1.y

        return Math.sqrt(dx * dx + dy * dy)
    }

    VizHitTracking.prototype.toXScale = function (playType, spec) {
        const minHitDistance = spec.minHitDistance || 77
        const maxHitDistance = spec.maxHitDistance || 370
        const domain = [minHitDistance, maxHitDistance]

        // switch (playType) {
        // 	case this.PLAY_TYPES.CAUGHT:
        // 		return d3.scaleLinear().domain(domain).range([133.4, 247.5]).clamp(true);
        // 	case this.PLAY_TYPES.DROPPED:
        // 	default:
        // 		return d3.scaleLinear().domain(domain).range([133.4, 226.5]).clamp(true);
        // }
        switch (playType) {
            case this.PLAY_TYPES.CAUGHT:
                return d3
                    .scaleLinear()
                    .domain(domain)
                    .range([spec.xTailMin, spec.xTailMaxCaught])
                    .clamp(true)
            case this.PLAY_TYPES.DROPPED:
            default:
                return d3
                    .scaleLinear()
                    .domain(domain)
                    .range([spec.xTailMin, spec.xTailMaxDropped])
                    .clamp(true)
        }
    }

    VizHitTracking.prototype.render = function (trackingData, spec, cb) {
        // console.info('received…');
        // console.info('spec.width: ' + spec.width);
        // console.info('spec.height: ' + spec.height);

        spec = this.toDefaultSpec(spec)

        // // for testing
        // spec.eventPillVisible = true;
        // spec.batterName = 'A. Rizzo';
        // spec.teamId = 110;

        // console.log('using…');
        // console.log('spec.width: ' + spec.width);
        // console.log('spec.height: ' + spec.height);
        // console.log('aspect ratio: ' + (spec.width / spec.height));

        // set y positions of elements
        this.updateDim()

        const { dim } = this
        const svg = this.clearSvg(spec)

        console.log(svg)
        const defs = this.defs()
        let gMain
        let gTail
        const vbParts = svg.attr('viewBox').split(' ')
        const vbw = +vbParts[2]
        const vbh = +vbParts[3]

        const hitMetrics = metrics.toHitMetrics(trackingData)

        const playType = this.toPlayType(trackingData)

        // isHomer = playType === this.PLAY_TYPES.HOMERUN,
        let isCaught = playType === this.PLAY_TYPES.CAUGHT
        let isDropped = playType === this.PLAY_TYPES.DROPPED
        let isMissed = playType === this.PLAY_TYPES.MISSED
        // isInParkHomer = this.isInsideParkHR(trackingData),
        const eventType = this.toEventType(trackingData)
        const viewType = this.toViewType(trackingData)

        // xScale only used for non-homer batted ball plays
        const xScale = this.toXScale(playType, spec)
        let pHead
        let pTail
        let dxTail
        const isLogoOrNameVisible = spec.batterName || spec.teamId
        // gMain ty for when logo|name displayed
        const gMainOffsetY = 0 // -15;

        // background rect
        svg.append('rect')
            .classed('background', true)
            .attr('width', spec.width)
            .attr('height', spec.height)

        gMain = svg.append('g').classed('main', true)

        // be sure to call addCss and addFont after clearSvg
        this.addCss(svg)
        this.addFont(svg)

        addGridPattern(defs)

        if (spec.endType === 'auto') {
            isCaught = this.isCaught(trackingData)
            isDropped = !isCaught
        }
        if (spec.endType !== 'auto') {
            isCaught = spec.endType === 'caught'
            isDropped = spec.endType === 'dropped'
            isMissed = spec.endType === 'missed'
        }

        if (isLogoOrNameVisible) {
            gMain.attr('transform', `translate(0,${gMainOffsetY})`)
            this.renderBelow(spec, svg, spec.teamId, spec.batterName)
        }

        pHead = dim.hit.head

        switch (viewType) {
            case this.VIEW_TYPES.WALL:
                pTail = dim.hit.tail.homer
                break
            case this.VIEW_TYPES.FIELDER:
                pTail = dim.hit.tail.caught
                pTail.x = xScale(hitMetrics.distance.value)
                break
            case this.VIEW_TYPES.BOUNCES:
                pTail = dim.hit.tail.dropped
                pTail.x = xScale(hitMetrics.distance.value)
                break
            default:
                pTail = dim.hit.tail.missed
        }

        const points3D = trajectory.reconstructSeriesToHeightThreshold(
            trackingData,
            -1
        )

        // Note: to2D normalizes y values so that first point's y is 0
        const points2DWorld = tutil.simplify(tutil.to2D(points3D), 3)

        const pointsView = xform.worldToView(points2DWorld)

        // scale to target endpoints x values, scaling x and y proportionally
        const pointsViewScaled = xform.xInterpolate(
            pointsView,
            pHead.x,
            pTail.x
        )

        // match target endpoints vertically
        const pointsViewYInterpolated = xform.yInterpolate(
            pointsViewScaled,
            pHead.y,
            pTail.y
        )

        // clamp to yViewMinApex, scaling to fit, if necessary
        // pointsViewYClamped = xform.yClampView(pointsViewYInterpolated, pHead, pTail, this.dim.yViewMinApex),

        // if logo|name displayed, compensate for the vertical translation of gMain
        const yTop = isLogoOrNameVisible
            ? this.dim.yViewMinApex - gMainOffsetY
            : this.dim.yViewMinApex
        const pointsViewYClamped = xform.yClampView(
            pointsViewYInterpolated,
            pHead,
            pTail,
            yTop
        )

        // final view model points
        const points = pointsViewYClamped

        const pApexView = _.min(points, (p) => p.y)

        const p0 = points[0]
        const p1 = points[1]
        let yTopHeightLine // top y view coordinate of height line

        const dx = p1.x - p0.x
        const dy = p1.y - p0.y
        const arcAngle = Math.atan2(dy, dx)
        const arcAngleDegrees = toDegrees(arcAngle)

        const v01 = {
            x: p1.x - p0.x,
            y: p1.y - p0.y,
        }
        const vlen = dist({ x: 0, y: 0 }, v01)
        const vNormal = {
            x: v01.y / vlen,
            y: -v01.x / vlen,
        }
        const marginBottom = 5
        const pVelo = {
            x: p1.x + marginBottom * vNormal.x,
            y: p1.y + marginBottom * vNormal.y,
        }
        const p1Arc = {
            x: p1.x,
            y: p1.y,
        }
        const p2Arc = {
            x: p1.x + 8,
            y: dim.yBase,
        }

        // account for spec.endType
        // HR defaults
        const isDistanceMetricHigh = spec.metricsDistanceVPos === 'high'
        const isHeightMetricHigh = spec.metricsHeightVPos === 'high'
        // TODOHI  move to dim in viz_base?
        const dimMetrics = {
            exitvelo: pVelo,
            // TODOHI  still need to handle option for height text below arc
            maxheight: {
                x: pApexView.x,
                y: isHeightMetricHigh
                    ? pApexView.y - dim.metrics.height.margin.bottom
                    : pApexView.y +
                      dim.metrics.height.margin.top +
                      dim.fontSize,
            },
            // distance defaults to VIEW_TYPE.WALL(HR)
            distance: {},
            hangtime: {
                // x: 258,
                x: 298,
                y: 18.5 - 5,
            },
            launchangle: {
                x: p2Arc.x + 4,
                y: p2Arc.y - 0.5 * (p2Arc.y - p1Arc.y),
            },
        }

        if (isHeightMetricHigh) {
            yTopHeightLine = pApexView.y + 3
        } else {
            yTopHeightLine =
                dimMetrics.maxheight.y + dim.metrics.height.margin.bottom

            // TODOHI  check if height text (dimMetrics.maxHeight.y) too low
            // TODOHI  if so, force height text above and recalculate yTopHeightLine
        }

        if (isLogoOrNameVisible) {
            switch (viewType) {
                case this.VIEW_TYPES.WALL:
                    dimMetrics.distance = {
                        x: 257,
                        y: dim.yBase + 16,
                    }
                    break
                case this.VIEW_TYPES.FIELDER:
                    dimMetrics.distance = {
                        x: pTail.x + 5,
                        y: dim.yBase + 16,
                    }
                    break
                case this.VIEW_TYPES.BOUNCES:
                    dimMetrics.distance = {
                        x: pTail.x - 25,
                        y: dim.yBase + 16,
                    }
                    break
                default:
                    dimMetrics.distance = {
                        // TODO    base on pTail.x like above?
                        x: 270,
                        y: dim.yBase + 16,
                    }
            }
        } else {
            switch (viewType) {
                case this.VIEW_TYPES.WALL:
                    if (isDistanceMetricHigh) {
                        dimMetrics.distance = {
                            x: 261,
                            y: dim.yBase - 70,
                        }
                    } else {
                        dimMetrics.distance = {
                            x: 255,
                            y: dim.yBase - 35,
                        }
                    }
                    break
                case this.VIEW_TYPES.FIELDER:
                    dimMetrics.distance = {
                        x: pTail.x + 23,
                        y: dim.yBase - 17,
                    }
                    break
                case this.VIEW_TYPES.BOUNCES:
                    dimMetrics.distance = {
                        x: pTail.x - 7,
                        y: dim.yBase - 25,
                    }
                    break
                default:
                    dimMetrics.distance = {
                        // TODO    base on pTail.x like above?
                        x: 270,
                        y: dim.yBase - 4,
                    }
            }
        }

        if (spec.referenceMarks) {
            drawReferenceGrid(gMain, vbw, vbh)
        }

        // this.addArrowheadDefs(defs, spec);

        // hit arc from tracking
        const line = d3
            .line()
            .x((d) => d.x)
            .y((d) => d.y)
            .curve(d3.curveLinear)

        gMain.append('path').classed('hit_arc', true).attr('d', line(points))

        addGrid(gMain, dim.yBase, spec.gridOpacity, points)

        // launch angle arc
        gMain
            .append('path')
            .classed('launch_angle', true)
            .attr(
                'd',
                `M ${p1Arc.x} ${p1Arc.y}A 40 20 60 0 1 ${p2Arc.x} ${p2Arc.y}`
            )

        // if (isHomer) {
        // 	this.addOutfieldWall(gMain, dim.yBase, spec);
        // }
        if (viewType === this.VIEW_TYPES.WALL) {
            this.addOutfieldWall(gMain, dim.yBase, spec)
        }

        this.addGround(gMain, spec)

        this.addPlate(gMain)

        this.addHitter(gMain, spec)

        // if (isCaught && !isHomer) {
        if (viewType === this.VIEW_TYPES.FIELDER) {
            dxTail = pTail.x - 266

            gTail = gMain
                .append('g')
                .classed('tail', true)
                .attr('transform', `translate(${dxTail}, 0)`)

            this.addFielder(gTail, spec)
        }

        // if (isDropped && !isHomer) {
        if (viewType === this.VIEW_TYPES.BOUNCES) {
            dxTail = pTail.x - 233

            gTail = gMain
                .append('g')
                .classed('tail', true)
                .attr('transform', `translate(${dxTail}, 0)`)

            this.addHops(gTail, spec)
        }

        renderHeightLine(gMain, dim, pApexView, yTopHeightLine)

        renderHitArcGradient(gMain, points)

        // ball at head of hit
        this.addBall(gMain, points[0])

        if (spec.hitTypeVisible) {
            gMain
                .append('text')
                .text(hitMetrics.hitType.value)
                .classed('annotation', true)
                .attr('x', 10)
                .attr('y', 20)
        }

        metric(
            gMain,
            `${Math.round(hitMetrics.exitVelocity.value)}`,
            ' mph',
            'exitvelo',
            'hit',
            dimMetrics.exitvelo,
            arcAngleDegrees,
            false
        )
        metric(
            gMain,
            `${Math.round(hitMetrics.maxHeight.value)}`,
            ' ft',
            'maxheight',
            null,
            dimMetrics.maxheight,
            0,
            'middle'
        )
        metric(
            gMain,
            `${Math.round(hitMetrics.distance.value)}`,
            ' ft',
            'distance',
            null,
            dimMetrics.distance,
            0,
            false
        )
        metric(
            gMain,
            `${Math.round(hitMetrics.launchAngle.value)}°`,
            '',
            'launchangle',
            null,
            dimMetrics.launchangle,
            0,
            false
        )
        if (spec.hangTimePillVisible) {
            let gTime

            // // hang time box outline
            // svg.append('rect')
            // 	.classed('hang_time', true)
            // 	.attr('x', dim.metrics.hangtime.rect.x)
            // 	.attr('y', dim.metrics.hangtime.rect.y)
            // 	.attr('width', dim.metrics.hangtime.rect.width)
            // 	.attr('height', dim.metrics.hangtime.rect.height);

            gTime = metric(
                svg,
                `${(+hitMetrics.hangTime.value).toFixed(1)}`,
                ' sec',
                'hangtime',
                'hangtime',
                dimMetrics.hangtime,
                0,
                'end'
            )

            // stopwatch icon
            addStopwatch(gTime)
        }

        // play result (event pill) at top left
        // does not display when eventType unknown
        if (spec.eventPillVisible && eventType !== this.EVENT_TYPES.OTHER) {
            renderEventPill(svg, dim, eventType)
        }

        if (spec.referenceMarks) {
            drawReference(gMain)
        }

        // return svg markup when called by graphics server
        cb && cb(d3.select(this.sel).html())
    }

    /**
     * Renders team logo and hitter name, if given
     * @param spec
     * @param svg
     * @param teamId
     * @param name
     */
    VizHitTracking.prototype.renderBelow = function (spec, svg, teamId, name) {
        // translate to right a little to handle widest logo, Braves
        const isHatLogo = spec.logoType === 'hat'
        const tx = isHatLogo ? -3 : 5
        const ty = 120
        const g = svg
            .append('g')
            .classed('below', true)
            .attr('transform', `translate(${tx},${ty})`)
        let logoPath

        if (teamId) {
            logoPath = this.toLogoPath(teamId, isHatLogo)

            // console.info('logoPath: ' + logoPath);

            const gLogo = g
                .append('g')
                .classed('logo', true)
                .attr('transform', 'translate(0, 2) scale(0.12)')

            if (isServerSide) {
                fs.readFile(logoPath, (err, buf) => {
                    console.log(`err: ${err}`)

                    if (err) throw err

                    const svg = buf.toString()

                    // console.log('SVG: '+ svg);

                    // TODOHI  checked with &svg=true option, but doesn't appear to be inserting the logo svg into gLogo
                    // gLogo.append('div').html(svg);
                    gLogo.html(svg)
                })
            } else {
                d3.xml(logoPath)
                    .mimeType('image/svg+xml')
                    .get((error, xml) => {
                        if (error) throw error

                        const el = xml.documentElement

                        gLogo.node().appendChild(el)
                    })
            }
        }

        if (name) {
            g.append('text')
                .text(name)
                .classed('name', true)
                .attr('x', isHatLogo ? 35 : 42)
                .attr('y', 13)
        }
    }

    // defaults to horizontally centered text
    function metric(el, text, units, id, className, p, angle, textAnchor) {
        units = units || ''
        textAnchor = textAnchor !== undefined ? textAnchor : 'start'
        angle = angle || 0

        // get text width
        let textWidth

        // temporary text to determine size
        el.append('text')
            .text(text)
            .attr('x', 40)
            .attr('y', 15)
            .each(function () {
                // TODOHI  not working in server context
                // textWidth = this.getComputedTextLength();
                textWidth = 20

                this.remove()
            })
            .append('tspan')
            .classed('units', true)
            .text(units)

        const g = el
            .append('g')
            .classed('metric', true)
            .classed(className, className !== null)
            .attr('transform', `translate(${p.x},${p.y}) rotate(${angle})`)

        g.append('text')
            .classed('metric', true)
            .classed(className, className)
            .text(text)
            .attr('id', id)
            .style('text-anchor', textAnchor)
            .attr('x', 0)
            .attr('y', 0)
            .append('tspan')
            .classed('units', true)
            .text(units)

        return g
    }

    function addGridPattern(defs) {
        const pat = defs
            .append('pattern')
            .attr('id', 'grid_pattern')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', 4)
            .attr('height', 4)
            .attr('patternUnits', 'userSpaceOnUse')

        // horizontal
        pat.append('line')
            .attr('x1', 0)
            .attr('y1', 0)
            .attr('x2', 4)
            .attr('y2', 0)
            .style('stroke', '#000')
            .style('strike-width', 1)

        // vertical
        pat.append('line')
            .attr('x1', 3)
            .attr('y1', 0)
            .attr('x2', 3)
            .attr('y2', 4)
            .style('stroke', '#000')
            .style('strike-width', 1)
    }

    function renderHitArcGradient(g, points) {
        const colorHead = '#FF7800'
        const colorTail = '#FF0000'
        const color = d3.interpolateLab(colorHead, colorTail)

        _.each(_.initial(points), (p, i) => {
            const q = points[i + 1]
            const f = i / points.length
            const c = color(f)

            // console.log('f: ' + f + ', color: ' + c);

            g.append('line')
                .attr('x1', p.x)
                .attr('y1', p.y)
                .attr('x2', q.x)
                .attr('y2', q.y)
                .style('stroke', c)
                .style('stroke-linecap', 'round')
                .style('stroke-width', 2)
        })
    }

    function renderHeightLine(g, dim, pApex, yTop) {
        const gLine = g.append('g').classed('height', true)
        const p1 = {
            x: pApex.x,
            y: dim.yBase - 3,
        }
        const p2 = {
            x: pApex.x,
            // y: Math.max(20, pApex.y) + 3
            y: yTop,
        }
        const p = _.extend({}, p1)

        while (p.y >= p2.y) {
            gLine
                .append('circle')
                .attr('cx', p1.x)
                .attr('cy', p.y)
                .attr('r', 0.75)

            p.y -= 3
        }
    }

    function addGrid(g, yBase, opacity, points) {
        opacity = opacity || 0.1

        const p1x = points[0]
        const p2x = _.last(points)

        points = points.slice()
        points.push({
            x: p2x.x,
            y: yBase - 3,
        })
        points.unshift({
            x: p1x.x,
            y: yBase - 3,
        })

        const pointsStr = _.map(points, (p) => `${p.x} ${p.y}`).join(', ')

        // create polygon
        g.insert('polygon', '.hit_arc')
            .attr('points', pointsStr)
            .style('fill', 'url(#grid_pattern)')
            .style('fill-opacity', opacity)
    }

    function addStopwatch(g) {
        const tx = -39
        const ty = -7.3
        const gWatch = g
            .append('g')
            .classed('stopwatch', true)
            // .attr('transform', 'translate(-13, -10)')
            .attr('transform', `translate(${tx},${ty}) scale(0.75)`)
            .style('stroke', 'none')
            .style('fill', 'none')
            .style('fill-rule', 'evenodd')

        gWatch.html(
            '<path d="M5.01804706,5.40898235 C5.01804706,5.73545294 4.75351765,5.99998235 4.42704706,5.99998235 C4.10075294,5.99998235 3.83622353,5.73545294 3.83622353,5.40898235 C3.83622353,5.08268824 4.10075294,4.81798235 4.42704706,4.81798235 C4.75351765,4.81798235 5.01804706,5.08268824 5.01804706,5.40898235 Z" id="center" fill="#000"></path>' +
                '<path d="M3.84289412,6.22231765 C3.77954118,6.28584706 3.67701176,6.28584706 3.61365882,6.22231765 C3.55030588,6.15914118 3.55030588,6.05678824 3.61365882,5.99308235 L6.26936471,3.33772941 C6.33254118,3.27437647 6.43507059,3.27437647 6.49842353,3.33755294 C6.56177647,3.40108235 6.5616,3.50361176 6.4986,3.56678824 L3.84289412,6.22231765 Z" id="hand" fill="#000"></path>' +
                '<path d="M4.4271,9.07392353 C2.41304118,9.07392353 0.774688235,7.43557059 0.774688235,5.42168824 C0.774688235,3.40780588 2.41304118,1.7691 4.4271,1.7691 C6.44115882,1.7691 8.07933529,3.40780588 8.07933529,5.42168824 C8.07933529,7.43557059 6.44115882,9.07392353 4.4271,9.07392353 M4.73098235,0.975511765 L4.73098235,0.951158824 L4.0251,0.949923529 L4.0251,0.985747059 C1.73098235,1.22045294 -1.76470588e-05,3.11680588 -1.76470588e-05,5.42168824 C-1.76470588e-05,7.88521765 1.98033529,9.88233529 4.44404118,9.88233529 C6.90757059,9.88233529 8.87592353,7.88521765 8.87592353,5.42168824 C8.87592353,3.07427647 7.0251,1.15162941 4.73098235,0.975511765" id="body" fill="#000"></path>' +
                '<polygon id="top_button_shaft" fill="#000" points="3.84864706 1.23529412 4.90747059 1.23529412 4.90747059 0.529411765 3.84864706 0.529411765"></polygon>' +
                '<polygon id="top-button_head" fill="#000" points="3.49570588 0.705882353 5.26041176 0.705882353 5.26041176 0 3.49570588 0"></polygon>' +
                '<polygon id="side_button" fill="#000" points="1.82537647 2.41888235 1.32631765 2.91811765 0.577729412 2.16935294 1.07678824 1.67011765"></polygon>'
        )
    }

    // TODOHI  size box to fit text size
    // note: temporary text trick doesn't work in server context, so have to estimate text width
    // TODOHI  center text in box
    function renderEventPill(g, dim, eventType) {
        const resultLines = EVENT_TEXT[eventType]
        // take count from last line - ITPHR's HOME RUN line, or the only line
        const charCount = resultLines[resultLines.length - 1].length
        // estimate text width as multiple of character count
        const textWidth = 10 * charCount
        const rectWidth = 1.1 * textWidth
        // rectWidth = dim.result.rect.width;

        g.append('rect')
            .classed('result', true)
            .attr('x', dim.result.rect.x)
            .attr('y', dim.result.rect.y)
            .attr('width', rectWidth)
            .attr('height', () => {
                if (resultLines.length === 1) {
                    return dim.result.rect.height
                }
                return dim.result.rect.height + 6
            })

        if (resultLines.length === 1) {
            g.append('text')
                .text(resultLines[0])
                .classed('result', true)
                .attr('x', dim.result.rect.x + 0.5 * rectWidth)
                .attr('y', dim.result.rect.y + dim.result.rect.height - 6)
        } else {
            // assume two lines
            g.append('text')
                .text(resultLines[0])
                .classed('result short', true)
                .attr('x', dim.result.rect.x + 0.5 * rectWidth)
                .attr('y', dim.result.rect.y + dim.result.rect.height - 11)

            g.append('text')
                .text(resultLines[1])
                .classed('result', true)
                .attr('x', dim.result.rect.x + 0.5 * rectWidth)
                .attr('y', dim.result.rect.y + dim.result.rect.height + 2)
        }
    }

    function drawReferenceGrid(g, w, h) {
        var g = g.append('g').classed('grid', true)
        _.each(_.range(0, 300, 10), (x, i) => {
            g.append('line')
                .attr('x1', x)
                .attr('y1', 0)
                .attr('x2', x)
                .attr('y2', h)
                .style('stroke', i % 5 === 0 ? '#888' : '#ccc')
                .style('stroke-opacity', 0.5)
                .style('stroke-width', 0.5)
        })
        _.each(_.range(0, 300, 10), (y, i) => {
            g.append('line')
                .attr('x1', 0)
                .attr('y1', y)
                .attr('x2', w)
                .attr('y2', y)
                .style('stroke', i % 5 === 0 ? '#888' : '#ccc')
                .style('stroke-opacity', 0.5)
                .style('stroke-width', 0.5)
        })
    }

    // Sample the SVG path uniformly with the specified precision.
    function samples(path, precision) {
        const n = path.getTotalLength()
        const t = [0]
        let i = 0
        const dt = precision

        while ((i += dt) < n) t.push(i)
        t.push(n)
        return t.map((t) => {
            const p = path.getPointAtLength(t)
            const a = [p.x, p.y]
            a.t = t / n
            return a
        })
    }

    // Compute quads of adjacent points [p0, p1, p2, p3].
    function quads(points) {
        return d3.range(points.length - 1).map((i) => {
            const a = [points[i - 1], points[i], points[i + 1], points[i + 2]]
            a.t = (points[i].t + points[i + 1].t) / 2
            return a
        })
    }

    // Compute stroke outline for segment p12.
    function lineJoin(p0, p1, p2, p3, width) {
        const u12 = perp(p1, p2)
        const r = width / 2
        let a = [p1[0] + u12[0] * r, p1[1] + u12[1] * r]
        let b = [p2[0] + u12[0] * r, p2[1] + u12[1] * r]
        let c = [p2[0] - u12[0] * r, p2[1] - u12[1] * r]
        let d = [p1[0] - u12[0] * r, p1[1] - u12[1] * r]

        if (p0) {
            // clip ad and dc using average of u01 and u12
            const u01 = perp(p0, p1)
            var e = [p1[0] + u01[0] + u12[0], p1[1] + u01[1] + u12[1]]
            a = lineIntersect(p1, e, a, b)
            d = lineIntersect(p1, e, d, c)
        }

        if (p3) {
            // clip ab and dc using average of u12 and u23
            const u23 = perp(p2, p3)
            var e = [p2[0] + u23[0] + u12[0], p2[1] + u23[1] + u12[1]]
            b = lineIntersect(p2, e, a, b)
            c = lineIntersect(p2, e, d, c)
        }

        return `M${a}L${b} ${c} ${d}Z`
    }

    // Compute intersection of two infinite lines ab and cd.
    function lineIntersect(a, b, c, d) {
        const x1 = c[0]
        const x3 = a[0]
        const x21 = d[0] - x1
        const x43 = b[0] - x3
        const y1 = c[1]
        const y3 = a[1]
        const y21 = d[1] - y1
        const y43 = b[1] - y3
        const ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21)
        return [x1 + ua * x21, y1 + ua * y21]
    }

    // Compute unit vector perpendicular to p01.
    function perp(p0, p1) {
        const u01x = p0[1] - p1[1]
        const u01y = p1[0] - p0[0]
        const u01d = Math.sqrt(u01x * u01x + u01y * u01y)
        return [u01x / u01d, u01y / u01d]
    }

    function drawReference(g) {
        // bat tip
        g.append('circle')
            .attr('cx', 40)
            .attr('cy', 101) // 124 height viewbox
            .attr('r', 0.5)
            .style('fill', '#13b709')
            .style('stroke', 'none')

        // helmet
        g.append('circle')
            .attr('cx', 18)
            .attr('cy', 86) // 124 height viewbox
            .attr('r', 0.5)
            .style('fill', '#13b709')
            .style('stroke', 'none')

        // back toe
        g.append('circle')
            .attr('cx', 9)
            .attr('cy', 116) // 124 height viewbox
            .attr('r', 0.5)
            .style('fill', '#13b709')
            .style('stroke', 'none')

        // front toe
        g.append('circle')
            .attr('cx', 31)
            .attr('cy', 116) // 124 height viewbox
            .attr('r', 0.5)
            .style('fill', '#13b709')
            .style('stroke', 'none')

        // ball center
        g.append('circle')
            .attr('cx', 40.5)
            .attr('cy', 97.5) // 124 height viewbox
            .attr('r', 0.5)
            .style('fill', '#13b709')
            .style('stroke', 'none')

        // hit tail
        g.append('circle')
            .attr('cx', 291.5)
            .attr('cy', 74.5) // 124 height viewbox
            .attr('r', 0.5)
            .style('fill', '#13b709')
            .style('stroke', 'none')
    }

    return VizHitTracking
})
